// extracted by mini-css-extract-plugin
export default {"wrapper":"gv-z","button":"hv-z","alternate":"iv-z","disabled":"jv-z","paymentWarning":"kv-z","fadeIn":"lv-z"};